import { useTheme } from '@mui/material';
import React from 'react';

export const WarningIcon = () => {
  const {
    palette: {
      warning: { main },
    },
  } = useTheme();
  return (
    <svg
      data-testid="toastWarningIcon"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M7.00004 0.333328C3.31837 0.333328 0.333374 3.31833 0.333374 7C0.333374 10.6817 3.31837 13.6667 7.00004 13.6667C10.6817 13.6667 13.6667 10.6817 13.6667 7C13.6667 3.31833 10.6817 0.333328 7.00004 0.333328ZM7.00004 11.1667C6.54004 11.1667 6.16671 10.7933 6.16671 10.3333C6.16671 9.87333 6.54004 9.5 7.00004 9.5C7.46004 9.5 7.83337 9.87333 7.83337 10.3333C7.83337 10.7933 7.46004 11.1667 7.00004 11.1667ZM8.14893 7.27777C7.78115 7.61722 7.5556 7.84 7.5556 8.11111H6.44449C6.44449 7.33944 6.97171 6.85277 7.39504 6.46111C7.83893 6.05111 8.11115 5.77722 8.11115 5.33333C8.11115 4.72055 7.61282 4.22222 7.00004 4.22222C6.38726 4.22222 5.88893 4.72055 5.88893 5.33333H4.77782C4.77782 4.10777 5.77449 3.11111 7.00004 3.11111C8.2256 3.11111 9.22226 4.10777 9.22226 5.33333C9.22226 6.28611 8.62726 6.83555 8.14893 7.27777Z"
        fill={main}
      />
    </svg>
  );
};

export const ErrorIcon = () => {
  const {
    palette: {
      error: { main },
    },
  } = useTheme();
  return (
    <svg
      data-testid="toastErrorIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M15.6733 12.8541L9.39558 1.69028C8.62733 0.32547 7.37374 0.32547 6.60549 1.69028L0.327808 12.8541C-0.440441 14.219 0.188791 15.3333 1.72285 15.3333H14.2782C15.8123 15.3333 16.4391 14.219 15.6733 12.8541ZM7.13717 4.85813C7.36399 4.60771 7.64934 4.4825 8.00053 4.4825C8.35173 4.4825 8.63708 4.6052 8.8639 4.85312C9.08584 5.09854 9.20047 5.40906 9.20047 5.78219C9.20047 6.10023 8.7322 8.45421 8.57611 10.1646H7.44691C7.31033 8.45421 6.8006 6.10023 6.8006 5.78219C6.8006 5.41407 6.91523 5.10605 7.13717 4.85813ZM8.84683 12.9969C8.61026 13.2323 8.32735 13.3525 8.00053 13.3525C7.67372 13.3525 7.39081 13.2323 7.15424 12.9969C6.91767 12.759 6.8006 12.4735 6.8006 12.1354C6.8006 11.7999 6.91767 11.5094 7.15424 11.2665C7.39081 11.0236 7.67372 10.9033 8.00053 10.9033C8.32735 10.9033 8.61026 11.0236 8.84683 11.2665C9.0834 11.5094 9.20047 11.7999 9.20047 12.1354C9.20047 12.4735 9.0834 12.759 8.84683 12.9969Z"
        fill={main}
      />
    </svg>
  );
};

export const SuccessIcon = () => {
  const {
    palette: {
      asseticPrimary: { main },
    },
  } = useTheme();
  return (
    <svg
      data-testid="toastSuccessIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C3.58293 0 0 3.58293 0 8C0 12.4171 3.58293 16 8 16C12.4171 16 16 12.4171 16 8C16 3.58293 12.4171 0 8 0ZM12.2049 5.52439L7.91463 11.8512C7.7878 12.039 7.58537 12.1659 7.38537 12.1659C7.18537 12.1659 6.96585 12.0561 6.82439 11.9171L4.30732 9.39756C4.13659 9.22683 4.13659 8.94634 4.30732 8.77561L4.92927 8.15366C5.1 7.98293 5.38049 7.98293 5.54878 8.15366L7.1878 9.79024L10.7488 4.53659C10.8854 4.33659 11.161 4.28537 11.361 4.41951L12.0902 4.91463C12.2878 5.04878 12.3415 5.32439 12.2049 5.52439Z"
        fill={main}
      />
    </svg>
  );
};

export const InfoIcon = () => <div data-testid="toastInfoIcon" />;
